import { aggregateEventBreakdown } from "../helpers";
import { EventBreakdownItem } from "./EventBreakdownItem";

export function EventBreakdown({ daily }) {
  const breakdown = aggregateEventBreakdown(daily);
  const events = Object.entries(breakdown).sort((first, second) => second[1] - first[1]);
  const maximum = events[0]?.[1] || 0;

  if (!events.length) return <p className="text-sm text-gray-500">Sem detalhamento de eventos no período.</p>;


  return (
    <div className="space-y-3">
      {events.map(([eventName, total]) => (
        <EventBreakdownItem
          key={eventName}
          eventName={eventName}
          total={total}
          maximum={maximum}
        />
      ))}
    </div>
  );
}
